import { Access, AccessResource } from "@/common/shared/models/Access";
import { AccessRepository } from "@/common/shared/repositories/accessRepository/AccessRepository";
import { UseCase } from "@/shared/datastructures/UseCase";
import { RequestHandler } from "@/shared/utils/RequestHandler";

export class AddAccessUseCase extends UseCase<Access, Access | undefined> {
  public constructor(private accessRepo: AccessRepository) {
    super();
  }

  public async do(input: Access): Promise<Access | undefined> {
    if (!input.valid) {
      throw new Error(
        "Die Freigabe, die erstellt werden soll ist nich voll definiert"
      );
    }

    await RequestHandler.handle(
      this.accessRepo.addAccess(input),
      this.response
    );

    return this.response.result;
  }
}
